import React, { useCallback } from 'react';
import { PortalReportsApi } from '../../../api/portalReports';
import { PortalInformesApi } from '../../../api/portalInformesApi';
import { PortalReportsLanding } from '../../portal/reports/PortalReportsLanding';

/**
 * Wrapper de "Ver portal como cliente" para Reportes (V1) e Informes: el landing decide
 * por la modalidad de la agencia, así que acá van las dos parejas de fetchers.
 * Reusa el render editorial del cliente real pero hace fetch al endpoint admin
 * scopeado al cliente que está previewing el agency user.
 */
export function PreviewPortalReports({ clientId }) {
    const listFn = useCallback(
        () => PortalReportsApi.listPreviewReports(clientId),
        [clientId]
    );
    const queryFn = useCallback(
        (viewId, dateRangeOverride) => PortalReportsApi.queryPreviewReport(clientId, viewId, dateRangeOverride),
        [clientId]
    );

    const informesListFn = useCallback(
        () => PortalInformesApi.listPreview(clientId),
        [clientId]
    );
    const informesQueryFn = useCallback(
        (informeId, dateRangeOverride) => PortalInformesApi.renderPreview(clientId, informeId, dateRangeOverride),
        [clientId]
    );

    return (
        <PortalReportsLanding listFn={listFn} queryFn={queryFn}
                              informesListFn={informesListFn} informesQueryFn={informesQueryFn} />
    );
}
